(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsDashboardController', TabObjectsDashboardController);

    TabObjectsDashboardController.$inject = ['$scope', '$state', '$window','$timeout','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'TabObjectsDashboard', 'TabObjects', '$uibModal', 'User', '$rootScope'];

    function TabObjectsDashboardController($scope, $state, $window,$timeout, ParseLinks, AlertService, pagingParams, paginationConstants, TabObjectsDashboard, TabObjects, $uibModal, User, $rootScope) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.filterBy = filterBy;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.applyFilter = applyFilter;
        vm.exportTable = exportTable;
        vm.parseStatus = parseStatus;
        vm.changePageSize = changePageSize;
        vm.exportTableView = exportTableView;
        vm.loadAllToExport = loadAllToExport;
        vm.parseStatusClass = parseStatusClass;
        vm.parseWarningLevel = parseWarningLevel;
        vm.toggleMetricsCheckbox = toggleMetricsCheckbox;

        vm.currentState = "tab-objects-dashboard";
        vm.currentStateFilter = "tab-objects-dashboard-filter";
        vm.fleet = {};
        vm.condition = {};
        vm.objectType = {};
        vm.selectedFleet = {};
        vm.selectedCondition = {};
        vm.selectedObjectType = {};
        vm.selectedFleet.selected = {};
        vm.selectedObjectType.selected = {};
        vm.tabObjects = [];
        vm.selectedFleets = [];
        vm.listFilter = pagingParams.filter;
        vm.charToSearch = pagingParams.search;
        vm.predicates = pagingParams.predicates;
        vm.selectedFleet.id = pagingParams.fleet;
        vm.firstAccess = pagingParams.firstAccess;
        vm.licence = $rootScope.licence;

        vm.filter = localStorage.getItem(vm.currentStateFilter);
        var retrievedOrder = localStorage.getItem(vm.currentState);
        vm.filterStatus = "-1";
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);
        if (vm.filter !== null && vm.filter !== "null" && vm.filter !== undefined) {
            vm.filter = JSON.parse(vm.filter);
            if (Object.keys(vm.filter).length > 0) {
                vm.selectedFleet.id = vm.filter.fleet;
                vm.selectedObjectType.id = vm.filter.objectType;
                vm.selectedCondition.name = vm.filter.condition;
                vm.filterUntracked = vm.listFilter == -1 ? "-1" : vm.filter.filterUntracked;
                vm.filterStatus = vm.filter.filterStatus ? vm.filter.filterStatus : "-1";
                vm.filterWip = vm.listFilter == -1 ? "-1" : vm.filter.filterWip;
            }
        } else {
            vm.filter = {};
        }

        vm.hide = pagingParams.hide;
        vm.tabObjectsToExport = [];
        vm.objectCounting = {
            online: 0,
            offline: 0,
            warning: 0,
            offlineTracked: 0
        };
        //boolean to set page ready
        vm.pageReady = false;

        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        User.checkTerms({}, onSuccessCheck, onErrorCheck);

        function onSuccessCheck() {
        }

        function onErrorCheck() {
            $uibModal.open({
                templateUrl: 'app/components/register-page/terms-conditions.html',
                controller: 'TermsConditionsController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                keyboard: false
            }).result.then(function () {
                $state.reload();
            });
        }

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadAll(notify) {
            var data = {
                query: vm.charToSearch,
                filter: pagingParams.filter,
                fleet: vm.selectedFleet.id,
                objectType: vm.selectedObjectType.id,
                condition: vm.selectedCondition.name,
                filterUntracked: vm.filterUntracked,
                filterStatus: vm.filterStatus,
                filterWip: vm.filterWip,
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort()
            };


            TabObjectsDashboard.query(data, onSuccess, onError);
            TabObjectsDashboard.stat({
                query: vm.charToSearch,
                fleet: vm.selectedFleet.id,
                objectType: vm.selectedObjectType.id,
                condition: vm.selectedCondition.name
            }, onSuccessDash, onError);

            function onSuccessDash(count) {
                vm.objectCounting.online = count[0];
                vm.objectCounting.offline = count[1];
                vm.objectCounting.warning = count[2];
                vm.objectCounting.offlineTracked = count[3];
            }


            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tabObjects = data;
                vm.page = pagingParams.page;
                vm.listFilter = pagingParams.filter;
                vm.pageReady = true;
                var retrievedHide = JSON.parse(localStorage.getItem('dashboardColumn'));
                vm.hideAndShow();
                if (retrievedHide !== null)
                    for (var hideColumn in retrievedHide) {
                        var id = retrievedHide[hideColumn];
                        if (id === "Metrics" || id === "Fleet" || id === "Type" || id === "Condition") {
                            vm.hide[id] = false;
                            $('#' + id).prop('checked', false);
                        } else {
                            vm.hide[id] = true;
                            $('#' + id).prop('checked', true);
                        }
                    }
                    if (data.length > 0)
                        vm.toggleMetricsCheckbox(vm.tabObjects[0].metricList.length);
                    else vm.toggleMetricsCheckbox(0);

                    if (vm.filter == 'null' || vm.filter == null || vm.filter == undefined)
                        vm.filter = {};
                    vm.filter.filterUntracked = vm.filterUntracked;
                    vm.filter.filterStatus = vm.filterStatus;
                    vm.filter.filterWip = vm.filterWip;
                    localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            data.query = vm.charToSearch;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                hide: vm.hide,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter,
                firstAccess: false
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        function parseStatus(obj) {
            return obj.wipStatus > 0 ? "Maintenance" : obj.objectOnline && obj.objectTracked ? "Online" : "Offline";
        }

        function parseStatusClass(obj) {
            return obj.objectOnline && obj.objectTracked ? (obj.wipStatus > 0 ? "text-warning" : "text-online") : obj.objectOnline ? "text-untracked" : "text-danger";
        }

        function parseWarningLevel(level) {
            return "warning-level " + (level === 0 ? "btn-lv-ok" : level < 3 ? "btn-lv-low" : level < 5 ? "btn-lv-medium" : "btn-lv-high");
        }

        function filterBy(filter) {
            vm.listFilter = filter == vm.listFilter ? -1 : filter;
            vm.transition();
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadAllToExport() {
            var dataExport = {
                page: 0,
                size: 200,
                ch: vm.charToSearch,
                filter: pagingParams.filter
            };

            function onSuccessExport(data, headers) {
                vm.totalItemsExport = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjectsToExport.push(data[i]);
                }
                if (vm.tabObjectsToExport.length < vm.totalItemsExport) {
                    dataExport.page = dataExport.page + 1;
                    TabObjectsDashboard.query(dataExport, onSuccessExport, onErrorExport);
                }
            }

            function onErrorExport(error) {
                AlertService.error(error.data.message);
            }

            if (vm.tabObjectsToExport.length < 1)
                TabObjectsDashboard.query(dataExport, onSuccessExport, onErrorExport);
        }

        function exportTable(type) {
            if (vm.tabObjectsToExport.length == vm.totalItemsExport) {
                if (type == 'pdf') {
                    $('#tableToExport').tableExport({
                        type: 'pdf',
                        pdfFontSize: '7',
                        escape: 'false',
                        tableName: 'ObjectDashboard'
                    });
                } else if (type != null) {
                    $('#tableToExport').tableExport({
                        type: type,
                        escape: 'false',
                        tableName: 'ObjectDashboard',
                        size: {0: 40, 1: 50, 3: 100, 7: 60}
                    });
                }
                vm.tabObjectsToExport = [];
            } else {
                $timeout(function () {
                    exportTableView(type);
                }, 200)
            }
        }

        function exportTableView(type) {
            var additionalMetric = 10 + vm.tabObjects[0].metricList.length;
            if (type === "pdf")
                $('#tableView').tableExport({
                    type: 'pdf',
                    pdfFontSize: '7',
                    escape: 'false',
                    ignoreColumn: [additionalMetric],
                    tableName: 'ObjectDashboard',
                    size: {0: 40, 1: 50, 3: 100, 7: 60}
                });
            else
                $('#tableView').tableExport({
                    type: type,
                    escape: 'false',
                    ignoreColumn: [additionalMetric],
                    tableName: 'ObjectDashboard'
                });
        }


        function applyFilter(fleet, objectType, condition) {
            if (fleet && fleet.id) {
                if (fleet.id > 0) {
                    vm.fleet = fleet;
                    vm.filter.fleet = fleet.id;
                } else {
                    vm.fleet = [];
                    vm.fleet = vm.selectedFleets;
                    vm.filter.fleet = -1;
                }
            }
            if (objectType && objectType.id) {
                vm.objectType = objectType;
                vm.filter.objectType = objectType.id;
            } else {
                vm.objectType.id = -1;
            }

            if (vm.filter) {
                if (condition && condition.name) {
                    vm.filter.condition = condition.name;
                } else {
                    vm.filter.condition = "All Conditions";
                }
            }
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));
            loadAll();
        }

        function toggleMetricsCheckbox(input) {
            if (input <= 0) {
                // $('li[hide-column-by]')[$('li[hide-column-by]').length-1].setAttribute("style", "display:none");
                $('li[hide-column-by="dashboardColumn.Metrics"]')[0].setAttribute("style", "display: none");
            } else {
                // $('li[hide-column-by]')[$('li[hide-column-by]').length-1].setAttribute("style", "display:block");
                $('li[hide-column-by="dashboardColumn.Metrics"]')[0].setAttribute("style", "display:block");
            }
        }

        var onSaveSuccess = function () {
            loadAll();
        }

        var onSaveError = function () {
        }

        vm.muteStatus = function (object) {
            object.objectMuted = !object.objectMuted;
            TabObjects.updateMute(object, onSaveSuccess, onSaveError);
        }

        vm.showStatus = function (status) {
            if (status)
                return "Mute off";
            else return "Mute on";
        }

        vm.showStatusWrench = function (status) {
            if (status)
                return "Unprocess";
            else return "Process";
        }

        vm.wipStatus = function (object, index) {
            $uibModal.open({
                templateUrl: 'app/dashboards/tab-objects-dashboard/tab-objects-wip-dialog.html',
                controller: 'WipDialogController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warning');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', function () {
                        return object;
                    }]
                }
            }).result.then(function () {
                if (vm.filterWip != -1) {
                    vm.tabObjects.splice(index, 1);
                }
            });
        }

        vm.hideAndShow = function () {
            if (vm.firstAccess == true) {
                vm.hide['Metrics'] = true;
                $('#Metrics').prop('checked', true);
                vm.hide['Fleet'] = true;
                $('#Fleet').prop('checked', true);
                vm.hide['Type'] = true;
                $('#Type').prop('checked', true);
                vm.hide['Condition'] = true;
                $('#Condition').prop('checked', true);
                vm.hide['Warnings'] = false;
                $('#Warnings').prop('checked',  false);
                vm.hide['Code'] = false;
                $('#Code').prop('checked', false);
                vm.hide['Name'] = false;
                $('#Name').prop('checked',  false);
                vm.hide['Description'] = false;
                $('#Description').prop('checked', false);
                vm.hide['Notes'] = false;
                $('#Notes').prop('checked',  false);
                vm.hide['LastEvent'] = false;
                $('#LastEvent').prop('checked', false);
            } else {
                $('#Warnings').prop('checked',  vm.hide['Warnings']);
                $('#Code').prop('checked', vm.hide['Code']);
                $('#Name').prop('checked',  vm.hide['Name']);
                $('#Fleet').prop('checked', vm.hide['Fleet']);
                $('#Type').prop('checked',  vm.hide['Type']);
                $('#Condition').prop('checked', vm.hide['Condition']);
                $('#Description').prop('checked', vm.hide['Description']);
                $('#Notes').prop('checked',  vm.hide['Notes']);
                $('#LastEvent').prop('checked', vm.hide['LastEvent']);
                $('#Metrics').prop('checked',  vm.hide['Metrics']);
            }
        }

    }
})();
/*
* angular.element(document.body).injector().get('$translate')('jotApp.tabObjects.warningLevel').then(function(translation) {
    console.log('Traduzione:', translation);
});*/
